import { faApple } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { Build } from '~/components/organisms/Build';

export type IAppAndroidBuildPageProps = {
  appId: string;
};

export const AppAndroidBuildPage: React.FC<IAppAndroidBuildPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppAndroidBuildPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('AppAndroidBuildPage.title')}
        subtitle={t('AppAndroidBuildPage.subtitle')}
        icon={<FontAwesomeIcon icon={faApple} />}
      />

      <Build appId={appId} platform="android" />
    </>
  );
};
